import React, { useEffect, useState } from "react";

export default function TeacherChat(props) {
  const [level, setLevel] = useState();

  useEffect(() => {
    setLevel(props.level);
  }, [props.level]);
  const renderLevel = () => {
    switch (level) {
      case "Class":
        return <div>Chatt</div>;
      case "Student":
        return <div>Student</div>;
      case "Program":
        return <div>Program</div>;
      default:
        return <div></div>;
    }
  };

  return <div>{renderLevel()}</div>;
}
